<template>
    <div>
        <a id="close_fmapp_sidebar" href="javascript:void(0)" class="close-fmapp-sidebar">
            <span class="feather-icon"><i data-feather="chevron-left"></i></span>
        </a>
        <input type="text" class="form-control form-control-sm" name="volltextsuche"
               placeholder="Ticketnummer, Volltext ..." @keyup="InputVolltextsuche()" v-model="volltextsuche">
        <hr>
        <select v-if="meldungskategorien_data.length" name="meldungskategorie" id="meldungskategorie"
                class="form-control form-control-sm mb-10 mt-25" v-model="meldungskategorie" @change="triggerSearchEvent()">
            <option value="" selected> - Meldungskategorie -</option>
            <option v-for="meldungskategorie in meldungskategorien_data" :value="meldungskategorie.id">
                {{meldungskategorie.bezeichnung}}
            </option>
        </select>
        <select v-if="meldungsvorlagen_data.length" name="meldungsvorlage" id="meldungsvorlage"
                class="form-control form-control-sm mb-10" v-model="meldungsvorlage" @change="triggerSearchEvent()">
            <option value="" selected> - Meldungsvorlage -</option>
            <option v-for="meldungsvorlage in meldungsvorlagen_data" :value="meldungsvorlage.id">
                {{meldungsvorlage.bezeichnung}}
            </option>
        </select>
        <select name="status" id="status" class="form-control form-control-sm mb-10" v-model="status"
                @change="triggerSearchEvent()">
            <option value="" selected> - Status -</option>
            <option value="1">Neu</option>
            <option value="2">Anonymisieren</option>
            <option value="3">Hauptverantwortung</option>
            <option value="4">In Bearbeitung</option>
            <option value="10">Wirksamkeitsüberprüfung</option>
            <option value="11">Erfolgreich</option>
        </select>
        <select v-if="verantwortlicher_data.length" name="verantwortlicher" id="verantwortlicher"
                class="form-control form-control-sm mb-10 mt-25" @change="triggerSearchEvent()" v-model="verantwortlicher">
            <option value="" selected> - Verantwortliche -</option>
            <option v-for="single_verantwortlicher in verantwortlicher_data" :value="single_verantwortlicher.id">
                {{single_verantwortlicher.name}}
            </option>
        </select>
        <div class="mb-10">
            <table class="w-100">
                <tr>
                    <td class="w-50">
                        <div class="pl-1">von:</div>
                    </td>
                    <td class="w-50">
                        <div class="pl-1">bis:</div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <input id="time_interval_from" class="form-control form-control-sm" name="time-period-start" type="date" :max="new Date().toISOString().split('T')[0]" @change="setTimeIntervalMin()" v-model="time_interval_from" />
                    </td>
                    <td>
                        <input id="time_interval_to" class="form-control form-control-sm" name="time-period-end" type="date" :max="new Date().toISOString().split('T')[0]" @change="setTimeIntervalMax()" v-model="time_interval_to" />
                    </td>
                </tr>
            </table>
        </div>
        <div class="row mt-25">
            <div class="col-3">
                <toggle-button id="switch_eigene"
                               @change="toggleSearch('switch_eigene')"
                               color="#00acf0"
                               :sync="true"
                               :value="switch_eigene"
                               v-model="switch_eigene"
                />
            </div>
            <div class="col-9">
                Nur eigene Meldungen
            </div>
        </div>
        <div class="row mt-25">
            <div class="col-3">
                <toggle-button id="switch_risiko"
                               @change="toggleSearch('switch_risiko')"
                               color="#00acf0"
                               :sync="true"
                               :value="switch_risiko"
                               v-model="switch_risiko"
                />
            </div>
            <div class="col-9">
                Risikomeldungen
            </div>
        </div>
        <hr>
        <div class="row mt-10">
            <button class="btn btn-sm btn-primary ml-auto mr-auto" @click="resetStoreData()">
                Reset Filter
            </button>
        </div>
    </div>
</template>

<script>

    // ***********  Localization ***************
    import Lang from 'lang.js'

    // get the data source
    import translations from '../../../vue-translations.js';

    //Bsp.: lang.get('auth.btn_login'));

    // ***********  Localization ***************

    export default {
        props: ['meldungskategorien_in','meldungsvorlagen_in', 'page_in',],
        components: {},
        data() {
            return {
                volltextsuche: null,
                last_select: "",
                meldungskategorien_data: this.meldungskategorien_in,
                meldungskategorie: "",
                meldungsvorlagen_data: this.meldungsvorlagen_in,
                meldungsvorlage: "",
                status: "",
                verantwortlicher: "",
                verantwortlicher_data: "",
                time_interval_from: null,
                time_interval_to: null,
                switch_eigene: false,
                switch_risiko: false,
                page: this.page_in,
                lang: null,
                debug:false,
            };
        },
        created() {
            var lang = new Lang();

            lang.setLocale(this.locale_in);

            if (lang.getLocale() === 'undefined') {
                lang.setLocale('de');
            }
            lang.setMessages(translations);
            this.lang = lang;
        },
        mounted() {
            this.getStoreData();
        },
        beforeCreate() {
            this.$store.$store.commit('restoreQueryDataEMelder');
        },
        watch: {},
        computed: {},
        methods: {
            InputVolltextsuche() {
                if (this.volltextsuche.length > 1 || this.volltextsuche == '') {
                    this.triggerSearchEvent();
                }
            },
            triggerSearchEvent() {
                this.$eventBus.$emit('EMeldersearchQuery', {
                    volltextsuche: this.volltextsuche,
                    meldungskategorie: this.meldungskategorie,
                    meldungsvorlage: this.meldungsvorlage,
                    status: this.status,
                    verantwortlicher: this.verantwortlicher,
                    time_interval_from: this.time_interval_from,
                    time_interval_to: this.time_interval_to,
                    switch_eigene: this.switch_eigene,
                    switch_risiko: this.switch_risiko,
                    page: this.page,
                });
            },
            setTimeIntervalMin() {
                $('#time_interval_to').attr({'min' : this.time_interval_from});
                this.triggerSearchEvent();
            },
            setTimeIntervalMax() {
                const today = new Date().toISOString().split('T')[0];
                if (this.time_interval_to !== "") {
                    $('#time_interval_from').attr({'max' : this.time_interval_to});
                } else {
                    $('#time_interval_from').attr({'max' : today});
                }
                this.triggerSearchEvent();
            },
            toggleSearch(value) {
                this.triggerSearchEvent();
            },
            getStoreData(){
                this.meldungskategorie = this.$store.$store.state.search_emelder.meldungskategorie;
                this.meldungsvorlage = this.$store.$store.state.search_emelder.meldungsvorlage;

                this.page = this.$store.$store.state.search_emelder.page;
                this.verantwortlicher = this.$store.$store.state.search_emelder.verantwortlicher;
                this.status = this.$store.$store.state.search_emelder.status;
                this.switch_eigene = this.$store.$store.state.search_emelder.switch_eigene;
                this.switch_risiko = this.$store.$store.state.search_emelder.switch_risiko;
                this.volltextsuche = this.$store.$store.state.search_emelder.volltextsuche;
                this.time_interval_from = this.$store.$store.state.search_emelder.time_interval_from;
                this.time_interval_to = this.$store.$store.state.search_emelder.time_interval_to;

                if(this.debug) {
                    console.log('getStoreData - Start');
                    console.log(this.$store.$store.state);
                    console.log('getStoreData - End');
                }

            },
            resetStoreData(){
                this.meldungskategorie = "";
                this.meldungsvorlage = "";
                this.page = null;
                this.verantwortlicher = "";
                this.status = "";
                this.switch_eigene = false;
                this.switch_risiko = false;
                this.volltextsuche = null;
                this.time_interval_from = null;
                this.time_interval_to = null;


                this.$store.$store.commit('resetQueryDataEMelder');

                this.$swal({
                    title: 'Erfolg',
                    text: "Ihre Filterung wurden zurückgesetzt",
                    type: 'success',
                    toast: true,
                    position: 'top-right',
                    showConfirmButton: false,
                    timer: 3000
                });

                this.triggerSearchEvent();
            },
        }
    };
</script>
<style scoped>
</style>
